import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import CushionCustomizer from './CustomCushion';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const CustomCushionPage = () => {
  const { id } = useParams(); // Gets the product ID from the URL
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        // Fetch the real product from your backend
        const res = await axios.get(`${API_BASE_URL}/api/products/${id}`);
        setProduct(res.data.product);
      } catch (error) {
        console.error("Failed to load product", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <h2>Loading Customizer...</h2>
      </div>
    );
  }

  if (!product) {
    return <h2 className="text-center mt-10">Product not found.</h2>;
  }

  return (
    <div className="page-wrapper">
      {/* Pass the real database product into our Customizer! */}
      <CushionCustomizer product={product} />
    </div>
  );
};

export default CustomCushionPage;